import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';
import SiteTab from './SiteTab';
import BrandTab from './BrandTab';
import LibrariesTab from './LibrariesTab';
import AiTab from './AiTab';
import EmailTab from './EmailTab';
import UsersTab from './UsersTab';
import MaintenanceTab from './MaintenanceTab';
import AuditTab from './AuditTab';
import DangerTab from './DangerTab';
const SECTIONS = [
    {
        id: 'site',
        label: 'Site',
        tabs: [
            { id: 'site', label: 'Site', icon: '🌐', hint: 'Identity + env' },
            { id: 'brand', label: 'Brand', icon: '🎨', hint: 'Tokens & palette' },
            { id: 'libraries', label: 'Libraries', icon: '📚', hint: 'AOS, Swiper, etc.' },
        ],
    },
    {
        id: 'integrations',
        label: 'Integrations',
        tabs: [
            { id: 'ai', label: 'AI', icon: '✨', hint: 'Providers & routing' },
            { id: 'email', label: 'Email', icon: '✉️', hint: 'SMTP for notifications' },
        ],
    },
    {
        id: 'access',
        label: 'Access',
        tabs: [
            { id: 'users', label: 'Users', icon: '👥', hint: 'Admin accounts' },
        ],
    },
    {
        id: 'system',
        label: 'System',
        tabs: [
            { id: 'maintenance', label: 'Maintenance', icon: '🛠', hint: 'GC, backups' },
            { id: 'audit', label: 'Activity', icon: '📋', hint: 'Audit + AI logs' },
            { id: 'danger', label: 'Danger zone', icon: '⚠️', hint: 'Destructive actions' },
        ],
    },
];
const ALL_IDS = SECTIONS.flatMap((s) => s.tabs.map((t) => t.id));
export default function SettingsLayout({ me, site }) {
    const [params, setParams] = useSearchParams();
    const tab = useMemo(() => {
        const t = params.get('tab');
        return ALL_IDS.includes(t) ? t : 'site';
    }, [params]);
    useEffect(() => {
        if (!params.get('tab'))
            setParams({ tab: 'site' }, { replace: true });
    }, []); // eslint-disable-line react-hooks/exhaustive-deps
    const activeSection = SECTIONS.find((s) => s.tabs.some((t) => t.id === tab));
    const activeTab = activeSection?.tabs.find((t) => t.id === tab);
    return (_jsxs("div", { className: "page-shell settings-shell-2pane", children: [_jsxs("aside", { className: "settings-sidebar", children: [_jsxs("div", { className: "settings-sidebar-head", children: [_jsx("h1", { children: "Settings" }), _jsx("p", { className: "muted small", children: "Site, integrations, access & system." })] }), _jsx("nav", { className: "settings-nav", role: "tablist", children: SECTIONS.map((s) => (_jsxs("div", { className: "settings-nav-section", children: [_jsx("div", { className: "settings-nav-section-label", children: s.label }), s.tabs.map((t) => (_jsxs("button", { role: "tab", "aria-selected": tab === t.id, className: `settings-nav-link${tab === t.id ? ' active' : ''}`, onClick: () => setParams({ tab: t.id }), title: t.hint, children: [_jsx("span", { className: "settings-nav-icon", children: t.icon }), _jsx("span", { className: "settings-nav-label", children: t.label })] }, t.id)))] }, s.id))) })] }), _jsxs("main", { className: "settings-content", children: [_jsxs("header", { className: "settings-content-head", children: [_jsx("div", { className: "muted small", children: activeSection?.label }), _jsxs("h2", { children: [activeTab?.icon, " ", activeTab?.label] }), activeTab?.hint && _jsx("p", { className: "muted small", children: activeTab.hint })] }), _jsxs("div", { className: "settings-content-body", children: [tab === 'site' && _jsx(SiteTab, {}), tab === 'brand' && _jsx(BrandTab, {}), tab === 'libraries' && _jsx(LibrariesTab, {}), tab === 'ai' && _jsx(AiTab, {}), tab === 'email' && _jsx(EmailTab, {}), tab === 'users' && _jsx(UsersTab, { me: me }), tab === 'maintenance' && _jsx(MaintenanceTab, {}), tab === 'audit' && _jsx(AuditTab, {}), tab === 'danger' && _jsx(DangerTab, { siteName: site.name })] })] })] }));
}
